import FilterForm from 'components/forms/FilterForm';
import { ASSESSMENT_ATTEMPT_STATUS_OPTIONS } from 'services/assessments';
import { CrudFilters, HttpError } from '@refinedev/core';
import { DatePicker, Form, Input, Select } from 'antd';
import { Dayjs } from 'dayjs';
import { IAssessmentAttempt } from 'interfaces/assessments';
import { ObjectiveAttemptsTable } from './ObjectiveAttemptsTable';
import { toRangeDateFilter } from 'services/date';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';

interface IObjectiveAttemptsFilter {
  email?: string;
  student?: string;
  statuses?: string[];
  period?: [Dayjs, Dayjs] | null;
}

export const TabObjectiveAttempts = () => {
  const params = useParams();
  const assessmentId = params.id;

  const { tableProps, searchFormProps } = useTable<
    IAssessmentAttempt,
    HttpError,
    IObjectiveAttemptsFilter
  >({
    resource: 'assessments/attempts',

    onSearch: ({ student, email, statuses, period }) => {
      const filters: CrudFilters = [
        {
          field: 'filter[by_assessment_id]',
          operator: 'eq',
          value: assessmentId
        },
        {
          field: 'filter[student]',
          operator: 'eq',
          value: student
        },
        {
          field: 'filter[email]',
          operator: 'eq',
          value: email
        },
        {
          field: 'filter[by_status][]',
          operator: 'eq',
          value: statuses?.length ? statuses : undefined
        },
        {
          field: 'filter[by_completed_range_date][]',
          operator: 'eq',
          value: toRangeDateFilter(period)
        }
      ];

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'filter[by_assessment_id]',
          operator: 'eq',
          value: assessmentId
        }
      ]
    }
  });

  return (
    <>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item label="Aluno" name="student" className="mb-0">
          <Input placeholder="Nome do aluno" className="w-64" />
        </Form.Item>
        <Form.Item label="E-mail" name="email" className="mb-0">
          <Input placeholder="E-mail do aluno" className="w-64" />
        </Form.Item>
        <Form.Item label="Status" name="statuses" className="mb-0">
          <Select
            mode="multiple"
            allowClear
            placeholder="Todos"
            options={ASSESSMENT_ATTEMPT_STATUS_OPTIONS}
            className="w-64"
          />
        </Form.Item>
        <Form.Item label="Finalizada entre" name="period" className="mb-0">
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            placeholder={['Data inicial', 'Data final']}
          />
        </Form.Item>
      </FilterForm>

      <ObjectiveAttemptsTable tableProps={tableProps} />
    </>
  );
};
